import { ActionIcon, Tooltip } from "@mantine/core"
import { IconBrandTeams } from "@tabler/icons-react"
import { modals } from "@mantine/modals"
import { SendTeamsMessageForm, TeamsMessageModalScrollArea } from "./SendTeamsMessageForm";

export const TeamsMessagePersonButton: React.FC<{ recipient: string; onBeforeOpenModal?: () => void }> = ({ recipient, onBeforeOpenModal }) => {

    const openModal = () => {
        const modalId = modals.open({
            title: 'Send message on Teams',
            children: (
                <SendTeamsMessageForm 
                    defaultSelectedStaff={[recipient]} 
                    onSuccess={() => modals.close(modalId)}
                />
            ),
            scrollAreaComponent: TeamsMessageModalScrollArea,
            styles: { content: { overflowY: 'hidden' } },
        })
    }

    return (
        <Tooltip label="Send message on Teams" withArrow>
            <ActionIcon
                size={'md'}
                variant="light"
                onClick={(event) => {
                    event.stopPropagation()
                    onBeforeOpenModal?.()
                    openModal()
                }}
            >
                <IconBrandTeams />
            </ActionIcon>
        </Tooltip>
    )
}
